import { createContext } from 'react';

import { captureException } from '@sentry/react';

export interface SchedulesErrorBoundaryContextInterface {
  captureException: typeof captureException;
}

const defaultValue: SchedulesErrorBoundaryContextInterface = {
  captureException,
};

export const SchedulesErrorBoundaryContext =
  createContext<SchedulesErrorBoundaryContextInterface>(defaultValue);
